var render = function render(){var _vm=this,_c=_vm._self._c;return _c('validated-input',{attrs:{"errors":_vm.errors}},[_c('input',_vm._g(_vm._b({directives:[{name:"a11y-required",rawName:"v-a11y-required",value:(_vm.required),expression:"required"}],ref:"input",class:_vm.$style.element,attrs:{"id":_vm.id,"placeholder":_vm.placeholder}},'input',_vm.overrideAttrs,false),_vm.overrideListeners)),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }